"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteNoteSwaggerMetadata = exports.getNoteByIdSwaggerMetadata = exports.getNotesSwaggerMetadata = exports.updateNoteSwaggerMetadata = exports.createNoteSwaggerMetadata = void 0;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const create_note_dto_1 = require("./dto/create-note.dto");
const update_note_dto_1 = require("./dto/update-note.dto");
const get_note_dto_1 = require("./dto/get-note.dto");
const createNoteSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_note_dto_1.CreateNoteDto), (0, swagger_1.ApiOperation)({
        summary: "Create a new note",
        description: "Create a new note",
    }), (0, swagger_1.ApiBody)({
        description: "Note data",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_note_dto_1.CreateNoteDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: messages_1.successMessage.noteCreation,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: { type: "string", example: messages_1.successMessage.noteCreation },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.noteCreationFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.noteCreationFailed,
                },
            },
        },
    }));
};
exports.createNoteSwaggerMetadata = createNoteSwaggerMetadata;
const updateNoteSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(update_note_dto_1.UpdateNoteDto), (0, swagger_1.ApiOperation)({
        summary: "Update a note",
        description: "Update a note",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Note ID",
        type: Number,
    }), (0, swagger_1.ApiBody)({
        description: "Note data",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(update_note_dto_1.UpdateNoteDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.noteUpdate,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.noteUpdate },
                data: {
                    type: "object",
                    properties: {
                        id: { type: "number", example: 1 },
                    },
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: messages_1.errorMessages.noteUpdateFailed,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: {
                    type: "string",
                    example: messages_1.errorMessages.noteUpdateFailed,
                },
            },
        },
    }));
};
exports.updateNoteSwaggerMetadata = updateNoteSwaggerMetadata;
const getNotesSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Get all notes",
        description: "Get all notes",
    }), ...Object.keys(get_note_dto_1.GetNotesDto.prototype).map((key) => (0, swagger_1.ApiQuery)({
        name: key,
        required: false,
        description: Reflect.getMetadata("swagger/apiModelProperties", get_note_dto_1.GetNotesDto.prototype, key)?.description,
        example: Reflect.getMetadata("swagger/apiModelProperties", get_note_dto_1.GetNotesDto.prototype, key)?.example,
    })), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.noteList,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.noteList },
                data: {
                    type: "object",
                    properties: {
                        data: {
                            type: "array",
                            items: {
                                $ref: (0, swagger_1.getSchemaPath)(get_note_dto_1.NoteDto),
                            },
                        },
                        count: { type: "number", example: 10 },
                    },
                },
            },
        },
    }));
};
exports.getNotesSwaggerMetadata = getNotesSwaggerMetadata;
const getNoteByIdSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(get_note_dto_1.NoteDto), (0, swagger_1.ApiOperation)({
        summary: "Get note by ID",
        description: "Get note by ID",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Note ID",
        type: Number,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.noteDetails,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.noteDetails },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(get_note_dto_1.NoteDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.noteNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.noteNotFound },
            },
        },
    }));
};
exports.getNoteByIdSwaggerMetadata = getNoteByIdSwaggerMetadata;
const deleteNoteSwaggerMetadata = () => {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Delete a note",
        description: "Delete a note",
    }), (0, swagger_1.ApiParam)({
        name: "id",
        description: "Note ID",
        type: Number,
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.noteDeleted,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.noteDeleted },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.errorMessages.noteNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.errorMessages.noteNotFound },
            },
        },
    }));
};
exports.deleteNoteSwaggerMetadata = deleteNoteSwaggerMetadata;
